import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import PropTypes from 'prop-types';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { TextField, Alert, Stack } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
// hooks
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useNavigate } from 'react-router';
// eslint-disable-next-line import/no-unresolved
import { PATH_AUTH } from 'src/routes/paths';
import useAuth from '../../../hooks/useAuth';
import useIsMountedRef from '../../../hooks/useIsMountedRef';

import { MIconButton } from '../../@material-extend';

// ----------------------------------------------------------------------

ChangePasswordForm.propTypes = {
  onSent: PropTypes.func,
  onGetEmail: PropTypes.func,
  token: PropTypes.any
};

export default function ChangePasswordForm({ onSent, onGetEmail, token }) {
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const { changePassword } = useAuth();
  const isMountedRef = useIsMountedRef();

  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string()
      .required('Confirm Password is required')
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
      token
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      try {
        console.log('values', values);
        await changePassword(values.password, values.token);
        enqueueSnackbar('Password Changed Successfully', {
          variant: 'success',
          action: (key) => (
            <MIconButton size="small" onClick={() => closeSnackbar(key)}>
              <Icon icon={closeFill} />
            </MIconButton>
          )
        });
        navigate(PATH_AUTH.login);
        // if (isMountedRef.current) {
        //   onSent();
        //   onGetEmail(formik.values.password);
        //   setSubmitting(false);
        // }
      } catch (error) {
        console.error(error);
        // if (isMountedRef.current) {
        //   setErrors({ afterSubmit: error.message });
        //   setSubmitting(false);
        // }
      }
    }
  });

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          {errors.afterSubmit && <Alert severity="error">{errors.afterSubmit}</Alert>}

          <TextField
            fullWidth
            {...getFieldProps('password')}
            type="password"
            label="Password"
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />

          <TextField
            fullWidth
            {...getFieldProps('confirmPassword')}
            type="password"
            label="Confirm Password"
            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
            helperText={touched.confirmPassword && errors.confirmPassword}
          />

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            // to={PATH_AUTH.login}
          >
            Update Password
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
